import { I18n } from 'react-redux-i18n';

export const permissionsInit = {
  cart: false,
  sphere: false,
  email: false,
  spot: false,
  clientCode: false,
  price: false,
  crossSelling: false,
  leadTime: false,
  stock: false,
  panel: false,
  similarity: false,
  purchaseEstimate: false,
  purchaseBilling: false,
  purchaseBankSlip: false,
  purchaseBankSlipStock: false,
  purchaseBankSlipMinDeliveryDate: false,
  purchaseDebit: false,
  purchaseCredit: false,
  purchaseCreditStock: false,
  purchaseCreditMinDeliveryDate: false,
  purchase: false,
  cartUsers: false,
  opicCode: true,
  soneparCode: true,
  firstApproved: false,
  secondApproved: false,
  purchasePaymentGateway: false,
  managerEmail: false,
  allowMixedPurchase: false,
};

export const enumPermissions = {
  CART: 'cart',
  EMAIL: 'email',
  SPHERE: 'sphere',
  SPOT: 'spot',
  CLIENT_CODE: 'clientCode',
  PRICE: 'price',
  CROSS_SELLING: 'crossSelling',
  LEAD_TIME: 'leadTime',
  STOCK: 'stock',
  PANEL: 'panel',
  SIMILARITY: 'similarity',
  PURCHASE_ESTIMATE: 'purchaseEstimate',
  PURCHASE_BILLING: 'purchaseBilling',
  PURCHASE_BANK_SLIP: 'purchaseBankSlip',
  PURCHASE_BANK_SLIP_STOCK: 'purchaseBankSlipStock',
  PURCHASE_BANK_SLIP_MIN_DELIVERY_DATE: 'purchaseBankSlipMinDeliveryDate',
  PURCHASE_DEBIT: 'purchaseDebit',
  PURCHASE_CREDIT: 'purchaseCredit',
  PURCHASE_CREDIT_STOCK: 'purchaseCreditStock',
  PURCHASE_CREDIT_MIN_DELIVERY_DATE: 'purchaseCreditMinDeliveryDate',
  PURCHASE: 'purchase',
  CART_USERS: 'cartUsers',
  OPIC_CODE: 'opicCode',
  SONEPAR_CODE: 'soneparCode',
  VISUALIZE_ALL_ORDERS: 'visualizeAllOrders',
  FIRST_APPROVED: 'firstApproved',
  SECOND_APPROVED: 'secondApproved',
  PURCHASE_PAYMENT_GATEWAY: 'purchasePaymentGateway',
  MANAGER_EMAIL: 'managerEmail',
  ALLOW_MIXED_PURCHASE: 'allowMixedPurchase',
};

export const defaultState = {
  password: '',
  passwordConfirm: '',
  checked: [],
  permissions: {
    cart: false,
    sphere: false,
    email: false,
    spot: false,
    clientCode: false,
    price: false,
    crossSelling: false,
    leadTime: false,
    stock: false,
    panel: false,
    similarity: false,
    purchaseEstimate: false,
    purchaseBilling: false,
    purchaseBankSlip: false,
    purchaseBankSlipStock: false,
    purchaseBankSlipMinDeliveryDate: false,
    purchaseDebit: false,
    purchaseCredit: false,
    purchaseCreditStock: false,
    purchaseCreditMinDeliveryDate: false,
    purchasePaymentGateway: false,
    purchase: false,
    cartUsers: false,
    opicCode: false,
    soneparCode: false,
    firstApproved: false,
    secondApproved: false,
    managerEmail: false,
    allowMixedPurchase: false,
  },
  role: 'store',
  status: 'active',
  message: '',

  email: '',
  firstname: '',
  lastName: '',
  fullName: '',

  newClient: true,

  contactId: '',

  userId: '',
  limit: 0,
};

export const initialState = {
  password: '',
  passwordConfirm: '',
  checked: [],
  role: 'store',
  status: 'active',
  message: '',
  success: '',

  client: '',
  email: '',
  firstname: '',
  lastName: '',
  fullName: '',
  hasUser: '',

  newClient: false,
  listContracts: '',

  contracts: [],
  contactId: '',

  userId: '',
  limit: 0,
};

export const config = [
  {
    name: I18n.t('visualization'),
    permissions: [
      // {
      //   id: 'similarity',
      //   label: 'visualizeSimilarity',
      // },
      // {
      //   id: 'crossSelling',
      //   label: 'visualizeCrossselling',
      // },
      {
        id: 'stock',
        label: 'visualizeStock',
      },
      {
        id: 'leadTime',
        label: 'visualizeLeadtime',
      },
      {
        id: 'opicCode',
        label: 'visualizeOpicCode',
      },
      {
        id: 'soneparCode',
        label: 'visualizeSoneparCode',
      },
    ],
  },
  {
    name: I18n.t('products'),
    permissions: [
      {
        id: 'price',
        label: 'visualizePrice',
      },
      {
        id: 'spot',
        label: 'visualizeSpot',
      },
    ],
  },
  {
    name: I18n.t('cart'),
    permissions: [
      {
        id: 'cart',
        label: 'visualizeCart', // acesso ao carrinho
      },
      {
        id: 'clientCode',
        label: 'visualizeClientCode',
      },
      {
        id: 'cartUsers',
        label: 'cartUser',
      },
      {
        id: 'purchaseEstimate',
        label: 'generateEstimate',
      },
      {
        id: 'managerEmail',
        label: 'managerEmail',
      },
      {
        id: 'allowMixedPurchase',
        label: 'allowMixedPurchase',
      },
    ],
  },
  {
    name: I18n.t('payment'),
    permissions: [
      {
        id: 'purchaseCredit',
        label: 'finalizePurchaseCredit',
      },
      {
        id: 'purchaseCreditStock',
        label: 'finalizePurchaseCreditStock',
        checkContainerStyle: { paddingLeft: '80px', paddingTop: '0px' },
      },
      {
        id: 'purchaseCreditMinDeliveryDate',
        label: 'finalizePurchaseCreditMinDeliveryDate',
        checkContainerStyle: { paddingLeft: '80px', paddingTop: '0px' },
      },
      {
        id: 'purchaseDebit',
        label: 'finalizePurchaseDebit',
      },
      {
        id: 'purchaseBankSlip',
        label: 'finalizePurchaseBankSlip',
      },
      {
        id: 'purchaseBankSlipStock',
        label: 'finalizePurchaseBankSlipStock',
        checkContainerStyle: { paddingLeft: '80px', paddingTop: '0px' },
      },
      {
        id: 'purchaseBankSlipMinDeliveryDate',
        label: 'finalizePurchaseBankSlipMinDeliveryDate',
        checkContainerStyle: { paddingLeft: '80px', paddingTop: '0px' },
      },
      {
        id: 'purchaseBilling',
        label: 'finalizePurchaseBilling',
      },
      {
        id: 'purchasePaymentGateway',
        label: 'finalizePurchasePaymentGateway',
      },
    ],
  },
  {
    name: 'Painel',
    permissions: [
      {
        id: 'visualizeAllOrders',
        label: 'visualizeAllOrders',
      },
    ],
  },
];

export default {
  permissionsInit,
  initialState,
  defaultState,
  config,
};
